// extracted by mini-css-extract-plugin
export default {"content":"Gallery_content_TrxrK","grid":"Gallery_grid_PiwFW","image":"Gallery_image_Xkntp"};